import {
    post,
    get,
    put,
} from "./http"

const shortlink = {
    // 增加短链
    add(params) {
        return post("client/yuexin-link/aim-code", params)
    },
    // 修改短链
    edit(params) {
        return put("client/yuexin-link/aim-code", params)
    },
    // 短链列表
    list(params){
        return get("client/yuexin-link", params)
    },
    // 短链详情
    detail(params) {
        return get("client/yuexin-link/aim-code/" + params)
    },
    // 启用禁用
    changeState(params) {
        return put("client/yuexin-link/aim-code/state", params)
    },
    //下载短链文件
    exportCsv(params){
        return get('client/yuexin-link/export',params)
    },
    //生成个性化短链
    dync(params){
        return post("client/yuexin-link/dyncAimUrl",params)
    },
    //下载个性化短链模板
    exportTemplate(params){
      return get('client/yuexin-link/exportExcel',params)
    },
    //查询模板报表数据
    queryReport(params){
        return get('client/yuexin-reprot/queryReport',params)
    },

    //导出模板报表
    exportReport(params){
        return get('client/yuexin-reprot/exportTpl',params)
    },

    //查询5G阅信报表
    query5GReport(params){
        return get('client/yuexin-reprot/query5g',params)
    },
}

export default shortlink
